<div class="ktbl-header-container">

  <!-- =====================================================
       LINKER BEREICH: Titel + Nebentitel
       ===================================================== -->
  <div class="ktbl-nav-links">

    <a
      routerLink="/"
      routerLinkActive="active"
      class="ktbl-title-link"
    >
      <h1 class="ktbl-header-h1">
        {{ titleHaupttitel }}
      </h1>

      <h2 class="ktbl-header-h2">
        {{ titleNebentitel }}
      </h2>
    </a>

  </div>


  <!-- =====================================================
       MITTLERER BEREICH: Navigation
       ===================================================== -->
  <div class="ktbl-nav-mitte ktbl-typografie-reg-18">

    <!-- Anleitung -->
    <a
      routerLink="/hilfe"
      routerLinkActive="active"
      class="ktbl-header-nav-link"
    >
      Anleitung
    </a>


    <!-- Vorlage-Download -->
    <div class="ktbl-header-dropdown-wrapper">

      <button
        class="ktbl-header-nav-link ktbl-header-dropdown-trigger ktbl-drop-down"
        type="button"
        id="dropdownInformation"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Vorlage-Download
      </button>

      <ul
        class="dropdown-menu"
        aria-labelledby="dropdownInformation"
      >

        <li>
          <button
            type="button"
            class="dropdown-item"
            (click)="downloadFileWinddatenCsv()"
          >
            CSV für Winddatenimport
            (
            <i
              class="fas fa-download ml-1 download-info ktbl-icon-vertical-align"
            ></i>

            {{ fileAppMetaDatas.winddatenCsv.endungText }}-Download
            {{ fileAppMetaDatas.winddatenCsv.sizeString }}
            )
          </button>
        </li>

      </ul>

    </div>

  </div>


  <!-- =====================================================
       RECHTER BEREICH: KTBL-Logo
       ===================================================== -->
  <div class="ktbl-nav-rechts">

    <a
      href="https://ktbl.de"
      class="ktbl-logo-link"
    >
      <img
        src="assets/globales-projekt-angular/img/ktbl-logo.png"
        alt="KTBL"
        class="ktbl-header-logo"
      />
    </a>

  </div>

</div>